// Static assets — real shop photos served from /public/photos
export const IMAGES = {
  hero: "/photos/img_1165.jpg",
  community: "/photos/img_0210.jpg",
  repairs: "/photos/img_3337.jpg",
  workshop: "/photos/workshop.jpg",
  fitting: "/photos/mtnbike_wild2.jpg",
  noteworthy: "/photos/brompton_noteworthy.jpg",
};

export const FITTING_STEPS = [
  { title: "Hello + Listen", desc: "We chat about your riding goals, pains, and dreams. No pressure, just listening." },
  { title: "Body Measurements", desc: "We take key measurements to understand how your body wants to interact with the bike." },
  { title: "On-Bike Assessment", desc: "You pedal, we observe. Small adjustments as we go, finding what feels right." },
  { title: "Dial It In", desc: "Saddle, bars, cleats — every contact point tuned for comfort, power, and joy." },
  { title: "Ride Happy", desc: "Leave with your bike fitted to YOU, plus notes you can keep forever." },
];

// Where services are performed
export const SERVICE_LOCATIONS = [
  { value: "noteworthy_cafe", label: "At Noteworthy Café" },
  { value: "at_home", label: "Mobile / At-Home Repair", note: "$50 minimum for at-home service" },
  { value: "event_trailer", label: "Shop Pop-Up — Full Trailer (events)" },
  { value: "event_kit", label: "Light Onsite Kit (events)" },
];

export const LOCATION_LABELS = SERVICE_LOCATIONS.reduce(
  (acc, l) => ({ ...acc, [l.value]: l.label }),
  {}
);

// Events page photo carousel
export const EVENTS_PHOTOS = [
  { src: "/photos/img_1165.jpg", caption: "Rolling shop, loaded and ready to wrench" },
  { src: "/photos/race_field.jpg", caption: "Race-day pop-up — rain or shine" },
  { src: "/photos/img_3309.jpg", caption: "The full trailer, parked trailside" },
  { src: "/photos/img_3291.jpg", caption: "Bike check station at the trailhead" },
  { src: "/photos/img_3337.jpg", caption: "Full workstand setup inside the trailer" },
  { src: "/photos/img_4433.jpg", caption: "BT Epic race weekend" },
  { src: "/photos/img_0210.jpg", caption: "Community group ride" },
  { src: "/photos/brompton_noteworthy.jpg", caption: "Wrench day at Noteworthy Café" },
  { src: "/photos/img_1185.jpg", caption: "City stop on a service ride" },
  { src: "/photos/mtnbike_wild.jpg", caption: "Trailhead tune before the ride" },
  { src: "/photos/workshop.jpg", caption: "Precision tools, mobile bench" },
  { src: "/photos/mtnbike_wild3.jpg", caption: "Trailside guests always welcome" },
];
